import React from 'react';
import styled from 'styled-components';

interface DeleteButtonProps {
  onClick: (e: React.MouseEvent) => void;
  onMouseDown: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
}

// 削除ボタン
const StyledDeleteButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  margin-left: auto;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  touch-action: manipulation;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #f44336;
  }
  
  &:active {
    background-color: rgba(0, 0, 0, 0.1);
    color: #d32f2f;
  }
`;

const DeleteButton: React.FC<DeleteButtonProps> = ({ onClick, onMouseDown, onTouchStart }) => {
  return (
    <StyledDeleteButton 
      onClick={onClick}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
      title="カードを削除"
    >
      ×
    </StyledDeleteButton>
  );
};

export default DeleteButton; 